
<div class="container">
  <div class="row row-with-bottom-padding">
    <div class="col-md-12">
      
      <div class="auth-box">

        <div class="logo-above-auth-box logo-tenant-as-background"></div>

        <!-- content -->
        <div class="auth-box-content-wrapper">

          <h2 class="auth-box_title">{{ 'forgot.title-success' | translate }}</h2>

          <p>
            <strong>{{ 'forgot.success-msg' | translate }} </strong><br/><br/>
            {{ 'forgot.success-msg-open-link' | translate }}
          </p>

        </div>

      </div>


    </div>
  </div>
</div>
